import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTheme } from "@mui/material/styles";

const MultiSelectRegionDropdown = (props) => {
    const [selectedRegion, setSelectedRegions] = useState([]);
    const theme = useTheme();

    const handleChangeRegion = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedRegions(value);
        props.handleRegionFilters(value);
    };

    useEffect(() => {
        // Apply role filters to the table...
    }, [selectedRegion]);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    function getStyles(name) {
        return {
            fontWeight:
                selectedRegion.indexOf(name) === -1
                    ? theme.typography.fontWeightRegular
                    : theme.typography.fontWeightMedium,
        };
    }

    return (
        <React.Fragment>
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-chip-label">
                    Select Regions
                </InputLabel>
                <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={selectedRegion}
                    onChange={handleChangeRegion}
                    input={
                        <OutlinedInput
                            id="select-multiple-chip"
                            label="Select Regions"
                        />
                    }
                    renderValue={(selected) => (
                        <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                            {selected.map((value) => (
                                <Chip key={value} label={value} />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {props.regionData.map((region) => (
                        <MenuItem
                            key={region}
                            value={region}
                            style={getStyles(region, theme)}
                        >
                            {region}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </React.Fragment>
    )
}

export default MultiSelectRegionDropdown;
